var GeneralPropertyAdapter = /** @class */ (function () {
    function GeneralPropertyAdapter(data) {
        this._direction = data.direction;
        this._minValue = data.min;
        this._maxValue = data.max;
        this._variableId = {
            dataSourceCode: data.dataSourceCode ? data.dataSourceCode : 0,
            variableName: {
                name: data.variableName,
                groupName: data.variableGroupName
            }
        };
        this._configureVariableId = {
            name: data.variableName,
            variableVersion: data.variableVersion ? data.variableVersion : undefined
        };
    }
    Object.defineProperty(GeneralPropertyAdapter.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        set: function (v) {
            this._direction = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyAdapter.prototype, "minValue", {
        get: function () {
            return this._minValue;
        },
        set: function (v) {
            this._minValue = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyAdapter.prototype, "maxValue", {
        get: function () {
            return this._maxValue;
        },
        set: function (v) {
            this._maxValue = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyAdapter.prototype, "variableId", {
        get: function () {
            return this._variableId;
        },
        set: function (v) {
            this._variableId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyAdapter.prototype, "configureVariableId", {
        get: function () {
            return this._configureVariableId;
        },
        set: function (v) {
            this._configureVariableId = v;
        },
        enumerable: true,
        configurable: true
    });
    return GeneralPropertyAdapter;
}());
export { GeneralPropertyAdapter };
